import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-profile-bank',
    templateUrl: './profile-bank.component.html',
    styleUrls: ['./profile-bank.component.scss']
})
export class ProfileBankComponent {

    @Input() paymentData: any;

    @Output() profileAction = new EventEmitter<{ section: string }>();

     onEditClick(): void {
        console.log('CLICK OK');
        this.profileAction.emit({ section: 'bank-modification'});
    }
}
